import { Payment, PaymentType, Task } from 'types';
import { BdoStatement } from './bdo-statement';

export enum LooseOrderSubtype {
	BigBag = 'big-bag',
}

export const getReadableLooseOrderSubtype = (type: LooseOrderSubtype): string => {
	switch (type) {
		case LooseOrderSubtype.BigBag:
			return 'Big Bag';

		default:
			return 'Nieznany';
	}
};

export enum BDO {
	BDO = 'bdo',
	producing = 'producing',
}

export const getReadableBdo = (bdo: BDO): string => {
	switch (bdo) {
		case BDO.BDO:
			return 'BDO';

		case BDO.producing:
			return 'Wytwarzający';

		default:
			return 'Nieznany';
	}
};

export enum PriceType {
	net = 'net',
	gross = 'gross',
}

export const getReadablePriceType = (priceType: PriceType): string => {
	switch (priceType) {
		case PriceType.net:
			return 'Netto';

		case PriceType.gross:
			return 'Brutto';

		default:
			return 'Nieznany';
	}
};

export interface LooseOrder {
	id: number;
	subtype: LooseOrderSubtype;
	clientId: number;
	bdo: BDO;
	wasteType: string;
	address: string;
	contact: string | null;
	count: number;
	onPlace: boolean;
	netPrice: number;
	grossPrice: number;
	wantedAdvance: number | null;
	priceType: PriceType;
	wantedPaymentType: PaymentType;
	comments: string | null;
	createdAt: Date;
	createdBy: number;
	bdoCardConfirmedAt?: string | null;
	bdoCardConfirmedBy?: number | null;
}

export type LooseOrderWithPayments = LooseOrder & {
	payments: Payment[];
};

export type FullLooseOrder = LooseOrder & {
	deliveryTask?: Task;
	claimingTask?: Task;
	payments: Payment[];
	bdoStatement?: BdoStatement | null;
};
